export const SHARE_MODAL_EN = {
  private: 'Private',
  shareInOrganisation: 'Share in Organisation',
  shareLink: 'Share Link'
}

export const SHARE_MODAL_DE = {
  private: 'Privat',
  shareInOrganisation: 'In Organisation teilen',
  shareLink: 'Link teilen'
}
